import { render, staticRenderFns } from "./BillingsTable.vue?vue&type=template&id=21f3b876&"
import script from "./BillingsTable.vue?vue&type=script&lang=ts&"
export * from "./BillingsTable.vue?vue&type=script&lang=ts&"
import style0 from "./BillingsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports